import styled from "@emotion/styled";
import { palette } from "@jnpmedi/grebob";

//NOTE: 고도화 시 해당 컴포넌트를 전체적으로 적용하도록 함.
export enum ResizeDirection {
  TOPLEFT = "nwse",
  TOP = "ns",
  TOPRIGHT = "nesw",
  RIGHT = "ew",
  BOTTOMRIGHT = "nwse",
  BOTTOM = "ns",
  BOTTOMLEFT = "nesw",
  LEFT = "ew",
}

const RESIZER_SIZE = "8px";

export function MarkerResizer({ onMouseDown }: { onMouseDown: (e: keyof ResizeDirection) => void }) {
  return (
    <>
      {Object.entries(ResizeDirection).map(([direction, cursor]) => {
        const top = direction.includes("TOP") ? `calc( -1 * 0.5 * ${RESIZER_SIZE})` : !direction.includes("BOTTOM") ? "50%" : undefined;
        const bottom = direction.includes("BOTTOM") ? `calc( -1 * 0.5 * ${RESIZER_SIZE})` : undefined;
        const left = direction.includes("LEFT") ? `calc( -1 * 0.5 * ${RESIZER_SIZE})` : !direction.includes("RIGHT") ? "50%" : undefined;
        const right = direction.includes("RIGHT") ? `calc( -1 * 0.5 * ${RESIZER_SIZE})` : undefined;

        const transform = `translate(${left === "50%" ? "-50%" : 0},${top === "50%" ? "-50%" : 0})`;

        return (
          <StyledMarkerResizeHandler
            key={direction}
            top={top}
            right={right}
            bottom={bottom}
            left={left}
            transform={transform}
            cursor={cursor}
            onMouseDown={() => onMouseDown(direction as keyof ResizeDirection)}
          />
        );
      })}
    </>
  );
}

const StyledMarkerResizeHandler = styled("div")<{
  top?: string;
  left?: string;
  bottom?: string;
  right?: string;
  transform: string;
  cursor: ResizeDirection;
}>(({ top, left, bottom, right, cursor, transform }) => ({
  position: "absolute",
  top,
  right,
  bottom,
  left,
  zIndex: "1",
  width: RESIZER_SIZE,
  height: RESIZER_SIZE,
  transform,
  border: "2px solid #19C2FF",
  backgroundColor: palette["white"],
  cursor: `${cursor}-resize`,
}));
